import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  registration: {
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    registerStart(state) {
      state.registration.status = "loading";
      state.registration.error = null;
    },
    registerSuccess(state) {
      state.registration.status = "succeeded";
      state.registration.error = null;
    },
    registerFailure(state, action) {
      state.registration.status = "failed";
      state.registration.error = action.payload || "Registration failed";
    },
    resetRegistration(state) {
      state.registration.status = "idle";
      state.registration.error = null;
    },
  },
});

export const {
  registerStart,
  registerSuccess,
  registerFailure,
  resetRegistration,
} = authSlice.actions;

export default authSlice.reducer;
